module.exports = __webpack_public_path__ + "static/rappi-2-2ace51a05665d9caf541739ce9a62b97.jpg";